<template>
	<header>
		<v-container>
			<div class="header__wrap pt-4 pt-md-7 d-flex align-md-center">
				<!-- <button class="header__burger mr-5 d-md-none" @click="toggleBurgerMenu">
					<svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M1.125 1.375H16.875M1.125 13.375H16.875H1.125ZM1.125 7.375H16.875H1.125Z"
							  stroke="#1F58AC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>
				</button> -->

				<div class="header__burger-wrap d-md-none" @click="toggleBurgerMenu">
					<div class="header__burger-icon"
						 :class="{'header__burger-icon--opened':isBurgerMenuShown}">
						<span></span>
						<span></span>
						<span></span>
					</div>
				</div>


				<router-link to="/" class="logo" @click="toggleMenuLogo">
					<svg width="93" height="19" viewBox="0 0 93 19" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
								d="M6.752 18.264C5.728 18.264 4.704 18.152 3.68 17.928C2.656 17.704 1.768 17.376 1.016 16.944C0.568 16.704 0.288 16.384 0.176 15.984C0.0640001 15.568 0.0880001 15.168 0.248 14.784C0.408 14.4 0.664 14.128 1.016 13.968C1.368 13.808 1.792 13.848 2.288 14.088C2.928 14.456 3.64 14.728 4.424 14.904C5.208 15.08 5.984 15.168 6.752 15.168C7.904 15.168 8.728 14.992 9.224 14.64C9.736 14.272 9.992 13.816 9.992 13.272C9.992 12.808 9.816 12.44 9.464 12.168C9.112 11.896 8.496 11.664 7.616 11.472L4.904 10.896C1.88 10.256 0.368 8.688 0.368 6.192C0.368 5.12 0.656 4.184 1.232 3.384C1.808 2.568 2.608 1.936 3.632 1.488C4.672 1.04 5.872 0.816 7.232 0.816C8.128 0.816 9.008 0.927999 9.872 1.152C10.736 1.36 11.496 1.672 12.152 2.088C12.552 2.328 12.8 2.64 12.896 3.024C12.992 3.408 12.96 3.776 12.8 4.128C12.656 4.48 12.4 4.728 12.032 4.872C11.68 5.016 11.24 4.96 10.712 4.704C10.184 4.432 9.624 4.232 9.032 4.104C8.44 3.976 7.832 3.912 7.208 3.912C6.2 3.912 5.416 4.112 4.856 4.512C4.312 4.896 4.04 5.4 4.04 6.024C4.04 6.488 4.208 6.864 4.544 7.152C4.88 7.44 5.464 7.672 6.296 7.848L9.008 8.424C12.112 9.096 13.664 10.616 13.664 12.984C13.664 14.04 13.376 14.968 12.8 15.768C12.24 16.552 11.44 17.168 10.4 17.616C9.376 18.048 8.16 18.264 6.752 18.264ZM21.191 18.264C19.927 18.264 18.823 18.016 17.879 17.52C16.951 17.008 16.231 16.296 15.719 15.384C15.207 14.456 14.951 13.36 14.951 12.096C14.951 10.848 15.207 9.768 15.719 8.856C16.231 7.928 16.951 7.216 17.879 6.72C18.823 6.224 19.927 5.976 21.191 5.976C22.455 5.976 23.551 6.224 24.479 6.72C25.423 7.216 26.151 7.928 26.663 8.856C27.191 9.768 27.455 10.848 27.455 12.096C27.455 13.36 27.191 14.456 26.663 15.384C26.151 16.296 25.423 17.008 24.479 17.52C23.551 18.016 22.455 18.264 21.191 18.264ZM21.191 15.552C21.959 15.552 22.583 15.272 23.063 14.712C23.559 14.152 23.807 13.28 23.807 12.096C23.807 10.928 23.559 10.072 23.063 9.528C22.583 8.968 21.959 8.688 21.191 8.688C20.423 8.688 19.799 8.968 19.319 9.528C18.839 10.072 18.599 10.928 18.599 12.096C18.599 13.28 18.839 14.152 19.319 14.712C19.799 15.272 20.423 15.552 21.191 15.552ZM32.6358 18.216C32.0438 18.216 31.5878 18.056 31.2678 17.736C30.9638 17.416 30.8118 16.96 30.8118 16.368V8.928H29.9478C29.0038 8.928 28.5318 8.48 28.5318 7.584C28.5318 6.672 29.0038 6.216 29.9478 6.216H30.8118C30.8438 4.584 31.2838 3.36 32.1318 2.544C32.9958 1.712 34.2438 1.216 35.8758 1.056L36.6438 0.983999C37.1718 0.935999 37.5558 1.04 37.7958 1.296C38.0518 1.536 38.1878 1.832 38.2038 2.184C38.2358 2.536 38.1558 2.856 37.9638 3.144C37.7878 3.416 37.5238 3.568 37.1718 3.6L36.8358 3.624C35.9718 3.688 35.3558 3.896 34.9878 4.248C34.6198 4.584 34.4358 5.104 34.4358 5.808V6.216H36.1398C37.0838 6.216 37.5558 6.672 37.5558 7.584C37.5558 8.48 37.0838 8.928 36.1398 8.928H34.4358V16.368C34.4358 17.6 33.8358 18.216 32.6358 18.216ZM45.8079 18.264C42.4959 18.264 40.8399 16.656 40.8399 13.44V8.928H39.8319C38.8879 8.928 38.4159 8.48 38.4159 7.584C38.4159 6.672 38.8879 6.216 39.8319 6.216H40.8399V4.392C40.8399 3.16 41.4479 2.544 42.6639 2.544C43.8639 2.544 44.4639 3.16 44.4639 4.392V6.216H46.7439C47.6719 6.216 48.1359 6.672 48.1359 7.584C48.1359 8.48 47.6719 8.928 46.7439 8.928H44.4639V13.296C44.4639 13.968 44.6159 14.472 44.9199 14.808C45.2399 15.144 45.7439 15.312 46.4319 15.312C46.6719 15.312 46.8959 15.288 47.1039 15.24C47.3119 15.192 47.5039 15.16 47.6799 15.144C47.9039 15.128 48.0879 15.2 48.2319 15.36C48.3759 15.52 48.4479 15.848 48.4479 16.344C48.4479 16.744 48.3839 17.088 48.2559 17.376C48.1279 17.648 47.9039 17.848 47.5839 17.976C47.3759 18.056 47.0879 18.12 46.7199 18.168C46.3679 18.232 46.0639 18.264 45.8079 18.264ZM52.463 18C51.167 18 50.519 17.352 50.519 16.056V3.024C50.519 1.728 51.167 1.08 52.463 1.08H57.143C60.023 1.08 62.255 1.816 63.839 3.288C65.423 4.744 66.215 6.824 66.215 9.528C66.215 12.232 65.423 14.32 63.839 15.792C62.255 17.264 60.023 18 57.143 18H52.463ZM54.239 14.952H56.927C60.527 14.952 62.327 13.144 62.327 9.528C62.327 5.928 60.527 4.128 56.927 4.128H54.239V14.952ZM74.5529 18.264C73.1609 18.264 71.9609 18.016 70.9529 17.52C69.9609 17.008 69.1929 16.296 68.6489 15.384C68.1209 14.456 67.8569 13.368 67.8569 12.12C67.8569 10.904 68.1129 9.84 68.6249 8.928C69.1529 8 69.8649 7.28 70.7609 6.768C71.6729 6.24 72.7209 5.976 73.9049 5.976C75.6169 5.976 76.9769 6.52 77.9849 7.608C78.9929 8.68 79.4969 10.136 79.4969 11.976C79.4969 12.584 79.1209 12.888 78.3689 12.888H71.3129C71.4409 13.816 71.7769 14.496 72.3209 14.928C72.8809 15.344 73.6489 15.552 74.6249 15.552C75.0089 15.552 75.4409 15.512 75.9209 15.432C76.4169 15.336 76.8889 15.176 77.3369 14.952C77.8009 14.728 78.1929 14.688 78.5129 14.832C78.8329 14.96 79.0489 15.184 79.1609 15.504C79.2889 15.824 79.2889 16.16 79.1609 16.512C79.0489 16.848 78.7849 17.128 78.3689 17.352C77.8089 17.656 77.1849 17.88 76.4969 18.024C75.8249 18.184 75.1769 18.264 74.5529 18.264ZM74.0489 8.376C73.2809 8.376 72.6569 8.608 72.1769 9.072C71.7129 9.536 71.4249 10.184 71.3129 11.016H76.4969C76.4009 9.256 75.5849 8.376 74.0489 8.376ZM86.7459 18.216C85.8019 18.216 85.1139 17.72 84.6819 16.728L81.0579 8.376C80.7859 7.752 80.7779 7.208 81.0339 6.744C81.2899 6.264 81.8179 6.024 82.6179 6.024C83.0499 6.024 83.4019 6.128 83.6739 6.336C83.9459 6.528 84.1859 6.904 84.3939 7.464L86.8659 13.704L89.4099 7.44C89.6339 6.896 89.8819 6.528 90.1539 6.336C90.4259 6.128 90.8019 6.024 91.2819 6.024C91.8899 6.024 92.3219 6.264 92.5779 6.744C92.8339 7.208 92.8179 7.744 92.5299 8.352L88.8339 16.728C88.4179 17.72 87.7219 18.216 86.7459 18.216Z"
								/>
					</svg>
				</router-link>
				<menu-items @select="onMenuItemSelected" :isHeader="true"
							class="d-none d-md-block pt-2"/>
			</div>
		</v-container>
		<burger-menu  v-if="isBurgerMenuShown" @select="onMenuItemSelected"
					 class="d-md-none"/>
	</header>
</template>

<style lang="scss">

	header {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		//background-image: url("~@/assets/header-bg-xs.png");
		height: 56px;
		background-size: cover;
		background-position: center center;
		z-index: 20;

		@include up($md) {
			height: 101px;
		}

		.logo {
			z-index: 10;
			margin-left: 25px;

			@include up($md) {
				margin-right: 64px;
				margin-left: 0;
			}
			@include up($lg) {
				margin-right: 170px;
			}

      path {
        fill: $primary-1;
      }

			&:hover {
				svg path {
					fill: $primary-2;
				}
			}
		}

		&:before {
			position: absolute;
			content: "";
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			backdrop-filter: blur(10px);
			background-color: $header-bg;

			z-index: -1;
		}
    @-moz-document url-prefix() {
      &:before {
        background-color: $header-bg-moz !important;
      }
    }

    li {
      font-family: $primary-font-family !important;
    }

		.header {
			&__burger-wrap {
				cursor: pointer;
				width: 16px;
				height: 12px;
				display: flex;
				justify-content: center;
				align-items: center;
				margin-top: 2px;
			}

			&__burger-icon {
				display: flex;
				width: 16px;
				height: 2px;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				margin-bottom: -5px;
				z-index: 20;

				@include transition();


				span {
					width: 100%;
					height: 2px;
					background-color: $primary-2;
					margin: -4px;
					border-radius: 25px;

					&:first-child {
						transform: none;
					}

					&:nth-child(2) {
						transform: none;
					}

					&:nth-child(3) {
						display: block;
					}
				}

				&--opened {
					margin-bottom: -10px;

					span {
						width: 100%;
						height: 2px;
						background-color: $primary-2;
						margin: -7px;
						border-radius: 25px;

						&:first-child {
							transform: translateY(-8.5px) rotate(45deg);
						}

						&:nth-child(2) {
							transform: translateY(3.5px) rotate(-45deg);
						}

						&:nth-child(3) {
							display: none;
						}
					}
				}
			}

		}
	}
</style>
<script>
    import BurgerMenu from "../../components/burger-menu";
    import MenuItems from "../../components/menu-items";

    export default {
        components: {MenuItems, BurgerMenu},

        data() {
            return {}
        },
        computed: {
            isBurgerMenuShown: {
                get() {
                    return this.$store.state.isBurgerMenuShown;
                },
                set(v) {
                    this.$store.state.isBurgerMenuShown = v;
                }
            }
        },
        methods: {
            toggleBurgerMenu() {
                this.isBurgerMenuShown = !this.isBurgerMenuShown;
            },
            onMenuItemSelected(item) {
                //console.log("Clicked detected in the header: ", item);
                this.isBurgerMenuShown = false;
            },
            toggleMenuLogo() {
                // todo wtf? is it always false? the name means TOGGLE
                this.isBurgerMenuShown = true;
                this.isBurgerMenuShown = !this.isBurgerMenuShown;
            },
            onSelectLang(item) {
                this.$store.state.currentLanguageCode = item.code;
            }
        },
    }
</script>
